module.exports = __webpack_public_path__ + "static/terminal-7066981a24086ec46af1ec5d1cac9396.svg";